import axios from "axios";

export default async function getCookieService(type: string) {
    try {
        const res = await axios.get(`/api/get-cookie?key=accountInfo-${type}`);

        if (res.status === 200) {
            return res.data;
        }
    } catch (error) {
        console.error("🚀 ~ getCookieService ~ error:", error);
        throw error;
    }
}
